import { $Q, $Qll } from "../utils/query-selector";

function productVideo() {
  const controls = $Qll('.button-media-js');

  controls.forEach((control) => {
    control.addEventListener('click', () => {
      const videoTemplate = $Q('template', control);
      const fragment = document.importNode(videoTemplate.content, true);
      const videoRender = $Q('div', fragment);

      control.insertAdjacentElement('afterend', videoRender);

      videoUnfocus(videoRender)
    })
  })
}

/**
 * Creates the interceptor for the node
 *
 * @param {Node} element - element container slider
 * @param {Function} callback - callback init slider
 */
const videoUnfocus = (video) => {
  const options = { rootMargin: "0px", threshold: 0.5 }

  const intersectionObserver = new IntersectionObserver(callbackVideo, options)
  intersectionObserver.observe(video);
}

/**
 * This function detects, by means of the observer
 *
 * @param {Node} entries - element node html, container slider
 * @param {Event} observer - observer event
 */
const callbackVideo = (entries, observer) => entries.forEach((entry) => {
  if (!entry.isIntersecting) {
    entry.target.remove();
    observer.unobserve(entry.target);
  }
})

export default productVideo;
